<template>
  <div class="clooned">
    <el-form
      :model="ruleFormdeit"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
    <!-- {{valueUiid}} -->
     <el-form-item label="请选择区域">
          <el-select
              v-model="ruleFormdeit.area_uuid"
              placeholder="请选择区域"
              @change="mychange"
              style="height:20px;width:100%"
            >
              <el-option
                v-for="item in optionsChiiend"
                :key="item.uuid"
                :label="item.areaname"
                :value="item.uuid"
              ></el-option>
            </el-select>
      </el-form-item>
      <el-form-item :label="dataobjs.wangguanid" prop="gatewayid">
        <el-input v-model="ruleFormdeit.gatewayid"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer list btenEtiel netListn" center style="display:block">
      <el-button @click="dialogVisiblecs('ruleForm')">{{dataobjs.quxiao}}</el-button>
      <el-button type="primary" @click="submitForm('ruleForm')">{{dataobjs.baocun}}</el-button>
    </span>
  </div>
</template>

<script>
import {lang_fend} from '@/network/index.js'
export default {
  props: {
    closefale: {
      type: Function,
      default: Function,
    },
    optionsChiiend:{
        type:Array,
        default:[]
    },
    valueUiid:{
      type:String,
      default:""
    },
    ruleFormdeit: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      rules: {
        gatewayid: [
          { required: true, message: "请输入网关id", trigger: "blur" },
          { min: 12, max: 12, message: "长度在 12 个字符", trigger: "blur" },
        ],
      },
      dataobjs:{}
    };
  },
  created() {},
  mounted() {
    this.lang_fend()
  },
  computed:{

  },
  methods: {
    mychange(e){
      // console.log(e);
      this.ruleFormdeit.area_uuid = e
        // console.log(this.optionsChiiend);   
    },
    // 翻译
        async lang_fend() {
      let page = "gateway_add_page";
      let objs = {
        page,
        lang_file: this.lang_file,
      };
      const { data, code } = await lang_fend(objs);
      // console.log(data);
      this.dataobjs = data;
    },
    // 取消
    dialogVisiblecs() {
       this.$refs.ruleForm.resetFields();
      this.closefale();
    },
    cloneHide(){
       this.$refs.ruleForm.resetFields();
    },
       dialogints() {
       this.$refs.ruleForm.resetFields();
       },
    // 保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
         
          // this.ruleFormdeit.area_uuid = this.valueUiid
          //  console.log(this.valueUiid);
          this.$emit('myListName',this.ruleFormdeit)  
          // console.log(this.ruleFormdeit);
          
        }
      });
    },
  },
};
</script>

<style scoped>
.netListn {
  text-align: center;
}
</style>
